import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '@app/core';
import { ServiceDownBannerData } from '@app/models';
import { GENERAL_MESSAGES } from '@app/shared/data/messages';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-service-down-warn',
    templateUrl: './service-down-warn.component.html',
    styleUrls: ['./service-down-warn.component.scss'],
    standalone: false
})
export class ServiceDownWarnComponent implements OnInit, OnDestroy {

  serviceDownBannerList: ServiceDownBannerData[] = [];
  @ViewChild('serviceDownDialogTemp') serviceDownDialogTemp!: TemplateRef<any>;
  pageMessages = GENERAL_MESSAGES;
  readonly unsubscribeAll$ = new Subject();

  constructor(
    private readonly _commonService: CommonService, 
    private readonly _matDialog: MatDialog
  ) {
    this._commonService.getServiceDownBannerValue
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe(
        response => {
          if (response.length) this.serviceDownBannerList = response.filter(rec => rec.is_service_down);
        }
      )
  }

  ngOnInit(): void {
    // no initial operations required
  }

  ngOnDestroy() {
    this.unsubscribeAll$.next(null);
    this.unsubscribeAll$.complete();
  }

  openAllWarnings() {
    if (!this.serviceDownDialogTemp) return;
    this._matDialog.open(this.serviceDownDialogTemp, { width: '580px', panelClass: 'no-padding-dialog', disableClose: true });
  }

  closeAllWarnings() {
    this._matDialog.closeAll();
  }

}
